// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"AdminPanel_mainWrapper__LZQg8","container":"AdminPanel_container__wK_et","errorContainer":"AdminPanel_errorContainer___a64b"};